import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingLayout } from '../../component/layout/LoadingLayout';
import { useAccessibleBenefits } from './useAccessibleBenefits';

interface Props {
  benefit: BenefitDTOBenefitEnum;
}

export const BenefitGuard: FC<PropsWithChildren<Props>> = ({ benefit, children }) => {
  const { accessibleBenefits, isLoading } = useAccessibleBenefits();

  if (isLoading) {
    return <LoadingLayout />;
  }

  if (!accessibleBenefits.has(benefit)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
